import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=3d3ce822&"
import script from "./dispatch.vue?vue&type=script&lang=js&"
export * from "./dispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d3ce822')) {
      api.createRecord('3d3ce822', component.options)
    } else {
      api.reload('3d3ce822', component.options)
    }
    module.hot.accept("./dispatch.vue?vue&type=template&id=3d3ce822&", function () {
      api.rerender('3d3ce822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/repair/repairManagement/dispatch.vue"
export default component.exports